// Dependencies
import React from "react";

// Modules
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";

// App
import { client, serverUrl, apiEndpoints } from "../../config";
import { getOnlineNode } from "../../core/getNode";
import Error from "../../partials/error";
import SkeletonSingleScreen from "../../partials/skeleton-screens/skeletonSingleScreen";
import { logCustomEvent } from "../../core/analytics";

export default function DocumentSingle(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const user = useSelector((state) => state).authReducer.user;
  const params = useParams();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("hash");

  useEffect(() => {
    loadNode();
    // eslint-disable-next-line
  }, []);

  const loadNode = () => {
    const nid = params.id;

    if (nid) {
      getContent(nid);
    } else {
      setErrorStatus(404);
      setErrorMessage("Not found");
      setIsError(true);
    }
  };

  /**
   * @function getContent
   * @description Retrieves the data from an API / Fallback to local realm object if there is no connection
   */
  const getContent = (nid) => {
    let path;

    if (client === "companyapp") {
      path = `${apiEndpoints.documents}?nid=${nid}&_format=json`;

      if (hash) {
        path = `${path}&auHash=${hash}`;
      }
    } else {
      path = `${apiEndpoints.documents}/all/${nid}?_format=json`;

      if (hash) {
        path = `/api/v2/shared?bundle=document&nid=${nid}&authkey=${hash}`;
      }
    }

    getOnlineNode(path, user.access_token)
      .then((response) => {
        if (response.data.rows.length > 0) {
          if (response.data.rows[0].field_document) {
            logCustomEvent("read", response.data.rows[0], "Document");
            window.location.href = `${serverUrl}/shared/files/${response.data.rows[0].filename}?access_token=${response.data.rows[0].file_access_token}`;
          } else {
            setErrorStatus(404);
            setErrorMessage("No data");
            setIsError(true);
          }
        } else {
          setErrorStatus(404);
          setErrorMessage("No data");
          setIsError(true);
        }
      })
      .catch((_error) => {
        if (_error?.response?.status === 403) {
          setErrorStatus(403);
          setErrorMessage("You do not have access to view this content.");
          setIsError(true);
        } else {
          setErrorStatus(500);
          setErrorMessage("Failed to get data");
          setIsError(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isLoading) {
    return <SkeletonSingleScreen />;
  } else {
    if (isError) {
      return <Error status={errorStatus} message={errorMessage} />;
    } else {
      return null;
      // let category = "Uncategorised";

      // if (post.category_labels) {
      //   category = post.category_labels;
      // }

      // return (
      //   <main className="documents single">
      //     <article className="article">
      //       <SinglesHeader
      //         route={"/documents"}
      //         backBtnText={"Documents"}
      //         category={category}
      //         timestamp={post.created}
      //         title={post.title}
      //       />
      //       <div className="article__body">
      //         <div class="ratio ratio-4x3">
      //           <embed
      //             src={`${serverUrl}/${post.field_document}`}
      //             className="w-100 h-100"
      //             type="application/pdf"
      //             style={{ minHeight: 500 }}
      //           />
      //         </div>
      //       </div>
      //     </article>
      //   </main>
      // );
    }
  }
}
